export * from './pdf-generator.type';
